import { toast, type ToastOptions } from 'react-toastify';
import { APP_CONFIG } from '@/constants/app.constants';

const defaultOptions: ToastOptions = {
  autoClose: APP_CONFIG.TOAST_AUTO_CLOSE_MS,
  position: 'top-right',
};

export const toastService = {
  success(message: string, options?: ToastOptions): void {
    toast.success(message, { ...defaultOptions, ...options });
  },
  error(message: string, options?: ToastOptions): void {
    toast.error(message, { ...defaultOptions, ...options });
  },
  warning(message: string, options?: ToastOptions): void {
    toast.warning(message, { ...defaultOptions, ...options });
  },
  info(message: string, options?: ToastOptions): void {
    toast.info(message, { ...defaultOptions, ...options });
  },
};
